import Cookies from "js-cookie";

export default () => {
    // Set the basketId for future usage.
    const cookieValue = Cookies.get("basket_id");

    if (!cookieValue || cookieValue === "undefined") {
        return false;
    }

    return cookieValue;
};
